import { useQuery } from '@tanstack/react-query';
import { api, LitCraftStoreProduct } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseStoreProductsReturn {
  gemBundles: LitCraftStoreProduct[];
  subscriptions: LitCraftStoreProduct[];
  loading: boolean;
  error: string | null;
}

export function useStoreProducts(): UseStoreProductsReturn {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: queryKeys.gameRewards.storeProducts(),
    queryFn: () => api.getLitCraftStoreProducts(),
  });

  return {
    gemBundles: data?.gemBundles ?? [],
    subscriptions: data?.subscriptions ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load store' : null,
  };
}
